<template>
  <div class="cart">
    <a-badge :count="shoppingCart.count"
             @click="changeDrawer">
      <shopping-cart-outlined class="cart-icon" />
      {{ $t('CustomSpus.ShoppingCart.cart') }}

    </a-badge>
  </div>
  <!-- 抽屉 -->
  <a-drawer v-model:visible="showShoppingCart"
            width="50%"
            :title="$t('CustomSpus.ShoppingCart.cart')"
            placement="right"
            :closable="false"
            :destroy-on-close="true">
    <template #extra>
      <close-outlined @click="showShoppingCart = false" />
    </template>
    <div class="shopping-cart-drawer">
      <div ref="hiddenContainer"
           class="hidden"></div>
      <a-table :row-selection="rowSelection"
               :columns="shoppingCartColumns"
               :data-source="shoppingCart.items"
               :pagination="false"
               row-key="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'customImages'">
            <div class="flex-box">
              <div class="image-box">
                <div v-if="hiddenContainer && record.is_custom"
                     class="viewer">
                  <CustomizedImagePreview :customized-data="mergeCustomAreaData(record)" />
                </div>
                <img v-else
                     :src="toUrl(record.image)"
                     class="viewer" />
              </div>
              <div class="item-flex">
                <!-- <div class="name_color">
                  {{ record.custom_spu_name }}
                </div> -->
                <div class="name_color">
                  {{ record.spu_name }}
                </div>
                <div>
                  <span v-for="(attr, index) in convertAttrs(record.sku_attrs)"
                        :key="index">
                    {{ attr.name }}:<span class="attr_color">{{ attr.value }}</span>
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'price'">
            <div>
              <div class="yellow-style">
                <div>￥{{ calcPrice.calcTotalPrice(record.price_detail, record.quality, true) }}</div>
                <a-popover placement="top">
                  <question-circle-outlined class="icon-margin" />
                  <template #content>
                    <price-breakdown :custom-price-detail="record.price_detail"
                                     :is-custom="record.is_custom"
                                     :quantity="record.quality"
                                     :is-order="false"></price-breakdown>
                  </template>
                </a-popover>
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'technology'">
            <div v-if="record.price_detail.custom_price.length"
                 class="technology-name">
              <span v-for="item in record.price_detail.custom_price">{{ item.name[0] + ' : ' }}{{ item.technology.name ?
                item.technology.name :
                '热转印'
              }}</span>
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template v-if="column.dataIndex === 'quantity'">
            <a-input v-model:value.number="record.quality"
                     class="quantity-input"
                     :disabled="(record.isRemoved || record.price_detail.custom_price.some((res: any) => res.deletedAt))"
                     @blur="qualityChange(record, $event, 'change')">
              <template #addonBefore>
                <div class="input-change"
                     :class="record.quality <= 1 ? 'input-disabled' : ''"
                     @click="record.quality <= 1 ? '' : qualityChange(record, $event, 'minus')">
                  <minus-outlined :class="record.quality <= 1 ? 'input-disabled' : ''" />
                </div>
              </template>
              <template #addonAfter>
                <div class="input-change"
                     :class="record.quality > 100000 ? 'input-disabled' : ''"
                     @click="record.quality > 100000 ? '' : qualityChange(record, $event, 'plus')">
                  <plus-outlined :class="record.quality > 100000 ? 'input-disabled' : ''" />
                </div>
              </template>
            </a-input>
          </template>
          <template v-if="column.dataIndex === 'operation'">
            <div class="delete_btn"
                 @click="deleteValue(record)">{{ $t('CustomSpus.ShoppingCart.delete') }}</div>
          </template>
        </template>
      </a-table>
    </div>
    <template #footer>
      <div style="float: left;">
        <a-button type="primary"
                  danger
                  class="delete-button"
                  @click="batchDelete">
          <delete-outlined class="delete-icon" />
          <span>{{ $t('CustomSpus.ShoppingCart.delete') }}
          </span>
        </a-button>
      </div>
      <div style="display: flex;justify-content: flex-end;">
        <div class="flex-amount">
          <span class="amount-title">{{ $t('CustomSpus.ShoppingCart.total') }}</span>
          <span class="amount-price">¥{{ money }} </span>
        </div>
        <a-button type="primary"
                  class="settle-btn"
                  :disabled="selectedItems.length <= 0"
                  @click="settlement">{{ $t('CustomSpus.ShoppingCart.settlement') }} </a-button>
      </div>
    </template>
  </a-drawer>

  <!-- 确认订单弹框 -->
  <a-drawer v-model:visible="confirm"
            :title="$t('CustomSpus.ShoppingCart.confirmOrder')"
            :destroy-on-close="true"
            placement="right"
            :closable="false"
            width="65%"
            @close="orderClose">
    <template #extra>
      <close-outlined @click="orderClose" />
    </template>
    <div class="order">
      <div class="order-title">{{ $t('CustomSpus.ShoppingCart.orderInfo') }}</div>
      <div class="shopping-cart-drawer">
        <div ref="orderHiddenContainer"
             class="hidden"></div>
        <a-table :columns="orderColumns"
                 :data-source="selectedItems"
                 :pagination="false"
                 row-key="id"
                 class="settle-table">
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.dataIndex === 'customImages'">
              <div class="flex-box">
                <div class="image-box">
                  <div v-if="orderHiddenContainer && record.is_custom"
                       class="viewer">
                    <CustomizedImagePreview :customized-data="mergeCustomAreaData(record)" />
                  </div>
                  <img v-else
                       :src="toUrl(record.image)"
                       class="viewer" />
                </div>
                <div class="item-flex">
                  <!-- <div class="name_color">
                    {{ record.custom_spu_name }}
                  </div> -->
                  <div class="name_color">
                    {{ record.spu_name }}
                  </div>
                  <div>
                    <span v-for="(attr, attrIndex) in convertAttrs(record.sku_attrs)"
                          :key="attrIndex">
                      {{ attr.name }}:<span class="attr_color">{{ attr.value }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="column.dataIndex === 'SupplyPrice'">
              <div class="yellow-style">
                <div class="black-style">￥{{ calcPrice.calcTotalPrice(record.price_detail, record.quality, false)
                }}&nbsp;
                </div>
                <div class="former-price">{{ new BigNumber(record.price).times(record.quality).toFixed(2) }}</div>
                <a-popover placement="top">
                  <question-circle-outlined class="icon-margin" />
                  <template #content>
                    <price-breakdown :custom-price-detail="record.price_detail"
                                     :is-custom="record.is_custom"
                                     :quantity="record.quality"
                                     :is-order="false"></price-breakdown>
                  </template>
                </a-popover>
              </div>
              <div>
                <div v-if="1"
                     class="coupon-remind"
                     @click="couponSelectionShow(record)"><img src="../icon/coupon.png"
                       alt="">&nbsp;{{ $t('CustomSpus.ShoppingCart.getCoupon') }}</div>
                <div v-else
                     class="no-coupon-remind"><img src="../icon/no-coupon.png"
                       alt="">&nbsp;{{
                        $t('CustomSpus.ShoppingCart.noDiscount') }}</div>
              </div>
            </template>
            <template v-if="column.dataIndex === 'aftercoupon'">
              <div class="aftercoupon">
                <span class="yellow-style">￥{{ moneyAfterDiscount(record, index) }}</span>
                <span>（{{ findCouponCondition(record.id)?.text || $t('CustomSpus.ShoppingCart.noDiscount') }}）</span>
              </div>
            </template>
            <template v-if="column.dataIndex === 'technology'">
              <div v-if="record.price_detail.custom_price.length"
                   class="technology-name">
                <span v-for="item in record.price_detail.custom_price">{{ item.name[0] + ' : ' }}{{ item.technology.name
                  ?
                  item.technology.name :
                  '热转印'
                }}</span>
              </div>
              <div v-else>
                -
              </div>
            </template>
            <template v-if="column.dataIndex === 'dssImageAmount'">
              <div class="aftercoupon">
                <span class="yellow-style">￥{{ clacDssImageAmount(record.dssData) }}</span>
              </div>
            </template>
          </template>
        </a-table>
        <ShoppingAddress :selected-items="selectedItems"
                         :express-list="expressList"
                         :is-design="false"
                         :tableRefList="tableRefList"></ShoppingAddress>
        <!-- <span class="order-express">
        <span style="color: #999;">快递费：</span>
        <span style="color: #DE4A09;">￥{{ isNaN(expressPrice) ? '' :
          expressPrice
        }}</span>
      </span> -->
      </div>
      <div class="order-title">{{ $t('CustomSpus.ShoppingCart.generalCoupon') }}
        <a-button v-if="selectedUniversalCouponList.length"
                  @click="changeCoupon">{{
                    $t('CustomSpus.ShoppingCart.reselectCoupon') }}</a-button>
      </div>
      <div v-if="!selectedUniversalCouponList.length"
           class="coupon"
           @click="couponSelectionShow()">
        <p>{{ $t('CustomSpus.ShoppingCart.noAvailableCoupons') }}</p>
        <span>{{ $t('CustomSpus.ShoppingCart.goToGet') }}
          <DoubleRightOutlined />
        </span>
      </div>
      <div v-else>
        <ul class="coupon-list-selected">
          <li v-for="item, index in selectedUniversalCouponList"
              v-show="item.activity_type == 'category' || item.activity_type == 'all'"
              :key="index"
              :class="['coupon-details', 'selected-coupon']">
            <div v-if="item.discount_amount"
                 class="coupon-price">
              <p class="coupon-symbol">￥</p>
              <span class="coupon-amount">{{ item.discount_amount }}</span>
            </div>
            <div v-else
                 class="coupon-price">
              <p class=" coupon-symbol">{{ $t('CustomSpus.ShoppingCart.discount') }} </p>
              <span class="coupon-amount">{{ removeLastZero(new
                BigNumber(item.discount_rate!).times(100).toNumber()) }}</span>
            </div>
            <div class="coupon-date">
              <p v-if="item.activity_type === 'all'"
                 class="coupon-rule">{{ $t('CustomSpus.ShoppingCart.noThreshold') }}
              </p>
              <p v-else
                 class="coupon-rule">{{ $t('CustomSpus.ShoppingCart.singleOrderThresholdPrefix') }}{{
                  item.threshold_amount }}{{ $t('CustomSpus.ShoppingCart.singleOrderThresholdSuffix') }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="express == 17"
           class="express-self-pickup">{{ $t('CustomSpus.ShoppingCart.selfPickup') }}</div>
      <div class="order-title">{{ $t('CustomSpus.ShoppingCart.orderRemarks') }}</div>
      <a-textarea v-model:value="remarks"
                  :placeholder="$t('CustomSpus.ShoppingCart.pleaseEnter')"
                  allow-clear />
      <div v-if="locale == 'zh_CN'"
           class="order-title">{{ $t('CustomSpus.ShoppingCart.paymentMethod') }}</div>
      <a-radio-group v-if="locale == 'zh_CN'"
                     v-model:value="payment">
        <a-radio :value="0">{{ $t('CustomSpus.ShoppingCart.alipay') }}</a-radio>
        <a-radio :value="1">{{ $t('CustomSpus.ShoppingCart.wechat') }}</a-radio>
        <a-radio v-if="userAccount"
                 :value="3">{{ $t('CustomSpus.ShoppingCart.wallet') }}</a-radio>
        <!-- <a-radio :value="2">微信小程序支付</a-radio>
        <a-radio :value="3">云闪付</a-radio>
        <a-radio :value="4">银行转账</a-radio> -->
      </a-radio-group>
      <div v-if="userSale"
           class="order-title">{{ $t('CustomSpus.ShoppingCart.adjustmentMethod') }}</div>
      <a-radio-group v-if="userSale"
                     v-model:value="adjustActiveKey"
                     :disabled="isNaN(pay_money)">
        <a-radio :value="'total'"
                 @click="adjustPrice('total')">{{ $t('CustomSpus.ShoppingCart.totalPriceAdjustment')
                }}</a-radio>
        <a-radio :value="'custom'"
                 @click="adjustPrice('custom')">{{ $t('CustomSpus.ShoppingCart.productPriceAdjustment')
                }}</a-radio>
      </a-radio-group>
    </div>
    <template #footer>
      <!-- <div style="float: left;">
        <a-button type="primary"
                  :disabled="isNaN(pay_money)"
                  class="settle-btn"
                  @click="adjustPrice">
          <span>调价</span>
        </a-button>
      </div> -->
      <div style="display: flex;justify-content: flex-end;">
        <div class="flex-amount">
          <span class="amount-title">{{ $t('CustomSpus.ShoppingCart.total') }}</span>
          <span v-if="!isAdjust"
                class="amount-price">¥{{ isNaN(pay_money) ? '' : pay_money }} </span>
          <span v-else
                class="amount-price">
            <span class="amount-price">¥{{ adjust_money() }}</span>
            <span class="former-price">¥{{ pay_money }}</span>
            <a-popover>
              <template #content>
                <FlashbaseAdjustDetail :sale-data="adjustDetail"
                                       :adjust-data="{}"
                                       :is-order="false"
                                       :is-adjust="false"
                                       :is-sale="true"></FlashbaseAdjustDetail>
              </template>
              <QuestionCircleOutlined :style="{ color: '#999', marginLeft: '10px' }" />
            </a-popover>
          </span>
        </div>
        <a-button type="primary"
                  :disabled="!isAdjust ? isNaN(pay_money) : isNaN(adjustDetail.pay_amount)"
                  :loading="modalLoading"
                  class="settle-btn"
                  @click="onSubmitOrder">{{ $t('CustomSpus.ShoppingCart.settlement')
                  }}</a-button>
      </div>
    </template>
  </a-drawer>



  <!-- 修改价格 -->
  <a-modal v-model:visible="adjustVisible"
           :title="$t('CustomSpus.ShoppingCart.adjustPrice')"
           :centered='true'
           :cancel-text="$t('CustomSpus.ShoppingCart.return')"
           :width="adjustActiveKey == 'total' ? '25%' : '60%'"
           :destroy-on-close="true"
           :body-style="{ padding: '20px', height: adjustActiveKey == 'total' ? '200px' : '600px' }"
           @cancel="adjustCancel">
    <div class="adjust-content">
      <div v-if="adjustActiveKey == 'total'"
           class="adjust-price">
        <div>{{ $t('CustomSpus.ShoppingCart.salesmanMinAdjustmentRate') }}：{{ userSale.rate }}%</div>
        <div>{{ $t('CustomSpus.ShoppingCart.totalPrice') }}：<span class="adjust-price-color">{{
          adjustTotalData.original_amonut }}</span></div>
        <div>{{ $t('CustomSpus.ShoppingCart.adjustment') }}：
          <span class="adjust-price-color">
            <a-input-number id="inputNumber"
                            v-model:value="adjustTotalData.pay_amount"
                            :min="new BigNumber(userSale.rate).div(100).times(adjustTotalData.original_amonut).toNumber().toFixed(2)" />
          </span>
          <span class="adjust-min-price">{{ $t('CustomSpus.ShoppingCart.minAdjustment') }}{{ new
            BigNumber(userSale.rate).div(100).times(adjustTotalData.original_amonut).toNumber().toFixed(2) }}</span>
        </div>
        <div>{{ $t('CustomSpus.ShoppingCart.adjustmentRate') }}：
          <span class="adjust-price-color">
            {{ rateChange(adjustTotalData.pay_amount, adjustTotalData.original_amonut) }}%
          </span>
        </div>
      </div>
      <div v-else>
        <div>{{ $t('CustomSpus.ShoppingCart.salesmanMinAdjustmentRate') }}：{{ userSale.rate }}%</div>
        <a-table class="settle-table"
                 :scroll="{ y: 400 }"
                 :columns="adjustColumns"
                 :data-source="adjustSelected"
                 :pagination="false"
                 row-key="id">
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'customImages'">
              <div class="flex-box">
                <div class="image-box">
                  <div v-if="orderHiddenContainer && record.is_custom"
                       class="viewer">
                    <CustomizedImagePreview :customized-data="mergeCustomAreaData(record)" />
                  </div>
                  <img v-else
                       :src="toUrl(record.image)"
                       class="viewer" />
                </div>
                <div class="item-flex">
                  <!-- <div class="name_color">
                    {{ record.custom_spu_name }}
                  </div> -->
                  <div class="name_color">
                    {{ record.spu_name }}
                  </div>
                  <div>
                    <span v-for="(attr, index) in convertAttrs(record.sku_attrs)"
                          :key="index">
                      {{ attr.name }}:<span class="attr_color">{{ attr.value }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="column.dataIndex === 'SupplyPrice'">
              <div class="adjust-price-color">￥{{ record.price }}</div>
            </template>
            <template v-if="column.dataIndex === 'aftercoupon'">
              <div class="aftercoupon">
                <span class="yellow-style">￥{{ record.coupon_price }}</span>
                <span>（{{ findCouponCondition(record.id)?.text || $t('CustomSpus.ShoppingCart.noDiscount') }}）</span>
              </div>
            </template>
            <template v-if="column.dataIndex === 'adjustPrice'">
              <a-input-number id="inputNumber"
                              v-model:value="record.adjust_price"
                              :min="new BigNumber(userSale.rate).div(100).times(record.coupon_price).toNumber().toFixed(2)"
                              @change="adjustPriceChange" />
            </template>
            <template v-if="column.dataIndex === 'minPrice'">
              <div class="adjust-price-color">
                {{ new BigNumber(userSale.rate).div(100).times(record.coupon_price).toNumber().toFixed(2) }}
              </div>
            </template>
            <template v-if="column.dataIndex === 'adjustRate'">
              <div class="adjust-price-color">
                {{ rateChange(record.adjust_price, record.coupon_price) }}%
              </div>
            </template>
          </template>
          <template #footer>
            <div>{{ $t('CustomSpus.ShoppingCart.totalPrice') }}：{{ adjustCustomData.original_amonut }}</div>
            <div>{{ $t('CustomSpus.ShoppingCart.shippingFee') }}：{{ orderExpressPrice }}</div>
            <div>{{ $t('CustomSpus.ShoppingCart.currentTotalPrice') }}：{{ adjustCustomData.pay_amount }}</div>
            <div>{{ $t('CustomSpus.ShoppingCart.adjustmentRate') }}：{{ rateChange(adjustCustomData.pay_amount,
              adjustCustomData.original_amonut) || 100 }}%</div>
          </template>
        </a-table>
      </div>
    </div>
    <template #footer>
      <a-button class="modal-btn btn-bgc"
                @click="adjustCancel">{{ $t('CustomSpus.ShoppingCart.cancel') }}</a-button>
      <a-button type="primary"
                class="modal-btn"
                @click="adjustSubmit">{{ $t('CustomSpus.ShoppingCart.confirm') }}</a-button>
    </template>
  </a-modal>

  <!-- 删除弹框 -->
  <a-modal v-model:visible="deleteVisible"
           :title="$t('CustomSpus.ShoppingCart.confirmDelete')"
           @ok="onDeleteOk"
           @cancel="deleteVisible = false">
    <p class="content-size">{{ deleteContent }}</p>
  </a-modal>
  <!-- 微信二维码 -->
  <a-modal v-model:visible="wxVisible"
           :title="$t('CustomSpus.ShoppingCart.wechatPay')"
           :z-index="1001"
           :mask-closable="false"
           @ok="onCancelOk"
           @cancel="wxVisible = false">
    <div class="flex">
      <a-image :width="200"
               :preview="false"
               :src="code_img" />
    </div>
    <div class="flex">
      {{ $t('CustomSpus.ShoppingCart.pleaseScanToPay') }}
    </div>
  </a-modal>
  <!-- paypal支付 -->
  <a-modal v-model:visible="paypalVisible"
           title="paypal"
           :z-index="1001"
           :mask-closable="false"
           @ok="paypalVisible = false"
           @cancel="paypalVisible = false">
    <Paypal :number="number"
            :price="price"></Paypal>
  </a-modal>
  <!-- 选择优惠券 -->
  <a-modal v-model:visible="couponVisible"
           :centered='true'
           width="700px"
           wrap-class-name="nicai"
           class="coupon-modal"
           :destroy-on-close="true"
           :body-style="{ padding: 0, 'min-height': '200px', 'max-height': '700px', position: 'relative' }"
           @cancel="couponCanel"
           @ok="couponOk">
    <a-tabs v-model:activeKey="activeKey"
            class="tab"
            :destroy-inactive-tab-pane="true"
            @change="changeTabList">
      <a-tab-pane key="1"
                  :tab="$t('CustomSpus.ShoppingCart.toBeUsed')">
        <ul v-if="myCouponList.length"
            class="coupon-list">
          <li v-for="item, index in myCouponList"
              v-show="!item.hide && (commodityId ? true : (item.activity_type == 'category' || item.activity_type == 'all'))"
              :key="index"
              :class="['coupon-details', couponType(item.id) ? 'selected-coupon' : '']"
              @click="selectedCoupon(item)">
            <div class="coupon-price">
              <p v-if="item.discount_amount"
                 class="coupon-symbol">￥</p>
              <p v-else
                 class="coupon-symbol">{{ $t('CustomSpus.ShoppingCart.discount') }}</p>
              <span v-if="item.discount_amount"
                    class="coupon-amount">{{ new BigNumber(item.discount_amount).toFixed(0)
                    }}</span>
              <span v-else
                    class="coupon-amount">{{ removeLastZero(new
                      BigNumber(item.discount_rate!).times(100).toNumber())
                    }}</span>
              <p class="coupon-rule">{{ item.threshold_amount && item.threshold_amount > 0 ?
                `${$t('CustomSpus.ShoppingCart.fullPayment')}${new
                  BigNumber(item.threshold_amount).toFixed(0)}${$t('CustomSpus.ShoppingCart.singleOrderThresholdSuffix')}`
                :
                item.activity_type === 'all' ? $t('CustomSpus.ShoppingCart.availableForAllProducts') :
                  $t('CustomSpus.ShoppingCart.specifiedProducts') }}</p>
            </div>
            <div class="coupon-date">
              <span>{{ dayjs(item.start_time).format('YYYY.MM.DD') + '-' +
                dayjs(item.end_time).format('YYYY.MM.DD') }}</span>
            </div>
            <div v-if="item.disabled"
                 class="coupon-reject">
              <ExclamationCircleOutlined />
              {{ $t('CustomSpus.ShoppingCart.couponNotApplicable') }}
            </div>
          </li>
        </ul>
        <div v-else
             class="no-coupon-message">
          <p>{{ $t('CustomSpus.ShoppingCart.goSeeCoupons') }}</p>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2"
                  :tab="$t('CustomSpus.ShoppingCart.toBeCollected')"
                  force-render>
        <div v-if="notCollectedCoupon.length">
          <ul class="coupon-list">
            <li v-for="item, index in notCollectedCoupon"
                :key="index"
                :class="['coupon-waiting', 'coupon-details', item.status == 1 ? 'selected-coupon' : '']"
                @click="getCoupons(item)">
              <div class="coupon-price">
                <p v-if="item.discount_amount"
                   class="coupon-symbol">￥</p>
                <p v-else
                   class="coupon-symbol">折</p>
                <span v-if="item.discount_amount"
                      class="coupon-amount">{{ new BigNumber(item.discount_amount).toFixed(0)
                      }}</span>
                <span v-else
                      class="coupon-amount">{{ removeLastZero(new
                        BigNumber(item.discount_rate!).times(100).toNumber()) }}</span>
                <p class="coupon-rule">{{ item.threshold_amount && item.threshold_amount > 0 ?
                  `${$t('CustomSpus.ShoppingCart.fullPayment')}${new
                    BigNumber(item.threshold_amount).toFixed(0)}${$t('CustomSpus.ShoppingCart.singleOrderThresholdSuffix')}`
                  : item.activity_type === 'all' ? $t('CustomSpus.ShoppingCart.availableForAllProducts') :
                    $t('CustomSpus.ShoppingCart.specifiedProducts') }}</p>
              </div>
              <div class="coupon-date">
                <p>{{ dayjs(item.start_time).format('YYYY.MM.DD') + '-' +
                  dayjs(item.end_time).format('YYYY.MM.DD') }}</p>
              </div>
              <div v-if='item.is_full'
                   class="coupon-unaccalimed">
                {{ $t('CustomSpus.ShoppingCart.allCollected') }}
              </div>
              <div v-else-if='!item.status'
                   class="coupon-received">
                {{ $t('CustomSpus.ShoppingCart.collectNow') }}
              </div>
              <div v-else-if="item.status === 1"
                   class="coupon-unaccalimed">
                {{ $t('CustomSpus.ShoppingCart.collected') }}
              </div>
            </li>
          </ul>
        </div>
        <div v-else
             class="no-coupon-message">{{ $t('CustomSpus.ShoppingCart.noDiscountActivities') }}</div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AccountInfoOption } from '../index'
import type { AccountInfoService } from '../../account-info/index'
import type { Plugin } from '@/plugins'
import { PLUGIN_ACCOUNT_INFO } from '@/plugins/builtin/BuiltinPluginSymbol'
import { toUrl } from '@/utils'
import { DefaultCouponHelper, DefaultCalcPriceHelper, type CanUseResult, type CouponItem, type Discount, type Item, type Order } from '@flashbase/util-coupon'
import { CustomizedImagePreview } from '@iota-cn/ui-components'
import { message, type TableColumnType, type TableProps } from 'ant-design-vue'
import BigNumber from "bignumber.js"
import dayjs from 'dayjs'
import QRCode from 'qrcode'
import { container } from 'tsyringe'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useShoppingCart } from '..'
import { useI18n } from 'vue-i18n'
import { addOrder, fetchDefaultAddress, getCouponList, getExpressRate, getExpress, getMyCouponList, receiveCoupon, wxpayQuery, getAccount } from '../api'
import type { Color, CouponCondition, ShoppingCartItem, SingleCoupon, AdjustItem, Reference } from "../types"
import { convertColor, renderImageBaseUrl, sortBy } from '../utils'
import PriceBreakdown from './components/PriceBreakdown.vue'
import ShoppingAddress from "./components/ShoppingAddress.vue"
// import Paypal from "./components/Paypal.vue"
import { CORE_LOCALE, type LocaleService } from '@/core'
const accountInfoPlugin = container.resolve<Plugin<AccountInfoOption, AccountInfoService>>(PLUGIN_ACCOUNT_INFO)
const language = container.resolve<LocaleService>(CORE_LOCALE)
const { t } = useI18n()
BigNumber.config({ ROUNDING_MODE: 1 })
const locale = language.currentLocale()

const couponResult = ref<Discount>()
const selectCouponList = ref<any[]>([])
const selectedSpecificCouponList = ref<SingleCoupon[]>([])
const selectedUniversalCouponList = ref<SingleCoupon[]>([])
const coupon = new DefaultCouponHelper()
const calcPrice = new DefaultCalcPriceHelper()
const commodityId = ref<number>(0)
const hiddenContainer = ref()
const orderHiddenContainer = ref()
const couponVisible = ref<boolean>(false)
const notCollectedCoupon = ref<SingleCoupon[]>([])
const myCouponList = ref<SingleCoupon[]>([])
const activeKey = ref<string>('1')
const restoreSelectedCoupon = ref<SingleCoupon[]>([])
const couponType = computed(() => (id: number) => {
  return commodityId.value ? selectedSpecificCouponList.value.find((r: any) => r.id === id) : selectedUniversalCouponList.value.find((r: any) => r.id === id)
})
const couponCondition = ref<CouponCondition[]>([])
// 购物车结算
const selectedItems = ref<ShoppingCartItem[]>([])
const selectedOriginOrderAddressItem = ref<ShoppingCartItem[]>([])
const selectedOrderAddressItem = ref<ShoppingCartItem[]>([])
const confirm = ref(false)
const moneyAfterDiscount = computed(() => (record: ShoppingCartItem, index: number) => {
  return couponResult.value ? couponResult.value?.itemDiscount[index]?.amount : calcPrice.calcTotalPrice(record.price_detail, record.quality, false)
})

const findCouponCondition = computed(() => (id: number) => {
  return couponCondition.value.find((r: CouponCondition) => r.commodityId === id)
})

const tableRefList = ref<any[]>([])

// const selectAddress = ref<any>({})

const shoppingCartColumns = computed<TableColumnType[]>(() => [
  {
    title: t('CustomSpus.ShoppingCart.product'),
    dataIndex: 'customImages',
    align: 'center',
    width: 350,
  },
  {
    title: t('CustomSpus.ShoppingCart.amount'),
    dataIndex: 'price',
    align: 'center',
    width: '120px',
  },
  {
    title: t('CustomSpus.ShoppingCart.process'),
    dataIndex: 'technology',
    align: 'center',
    width: '120px',
  },
  {
    title: t('CustomSpus.ShoppingCart.quantity'),
    dataIndex: 'quantity',
    align: 'center',
  },
  {
    title: t('CustomSpus.ShoppingCart.operation'),
    dataIndex: 'operation',
    align: 'center',
    width: '116px'
  },
])

const orderColumns = computed<TableColumnType[]>(() => [
  {
    title: t('CustomSpus.ShoppingCart.productInfo'),
    dataIndex: 'customImages',
    align: 'center',
    width: '25%',
  },
  {
    title: t('CustomSpus.ShoppingCart.process'),
    dataIndex: 'technology',
    align: 'center',
    width: '10%',
  },
  {
    title: t('CustomSpus.ShoppingCart.quantity'),
    dataIndex: 'quality',
    align: 'center',
    width: '10%',
  },
  {
    title: t('CustomSpus.ShoppingCart.supplyPrice'),
    dataIndex: 'SupplyPrice',
    align: 'center',
    width: '15%',
  },
  {
    title: t('CustomSpus.ShoppingCart.priceAfterCoupon'),
    dataIndex: 'aftercoupon',
    align: 'center',
    width: '15%',
  }, {
    title: t('CustomSpus.ShoppingCart.materialTotalPrice'),
    dataIndex: 'dssImageAmount',
    align: 'center',
    width: '15%',
  }
])
const adjustColumns = computed(() => [
  {
    title: t('CustomSpus.ShoppingCart.product'),
    dataIndex: 'customImages',
    align: 'center',
    width: 400,
  },
  {
    title: t('CustomSpus.ShoppingCart.quantity'),
    dataIndex: 'quality',
    align: 'center',
  },
  {
    title: t('CustomSpus.ShoppingCart.supplyPrice'),
    dataIndex: 'SupplyPrice',
    align: 'center',
  },
  {
    title: t('CustomSpus.ShoppingCart.priceAfterCoupon'),
    dataIndex: 'aftercoupon',
    align: 'center',
  },
  {
    title: t('CustomSpus.ShoppingCart.adjustPrice'),
    dataIndex: 'adjustPrice',
    align: 'center',
  },
  {
    title: t('CustomSpus.ShoppingCart.minPrice'),
    dataIndex: 'minPrice',
    align: 'center',
  },
  {
    title: t('CustomSpus.ShoppingCart.adjustRate'),
    dataIndex: 'adjustRate',
    align: 'center',
  },
])

const shoppingCart = useShoppingCart()

const removeLastZero = (number: number) => {
  let numberStr = number.toString()
  // 如果字符串以0结尾，移除最后一个字符
  if (numberStr.endsWith('0')) {
    numberStr = numberStr.slice(0, -1)
  }
  const result = parseInt(numberStr, 10)
  return result
}
// 快递
const expressList = ref<any[]>([])
const express = ref()
// 确认按钮异步关闭
const modalLoading = ref<boolean>(false)
const userSale = ref()
const userAccount = ref()
onMounted(async () => {
  await shoppingCart.fetch()
  if (shoppingCart.items.find((r: ShoppingCartItem) => (r.isRemoved || r.price_detail.custom_price.some(res => res.deletedAt))))
    message.info(t('CustomSpus.ShoppingCart.productRemoval'))
  const expressCompanies: any = await getExpress()
  expressList.value = expressCompanies.companies
  const data = localStorage.getItem('user')
  userSale.value = data ? JSON.parse(data).user.sale : null
  userSale.value ? payment.value = 1 : ''
  userAccount.value = await getAccount()
  locale.value == "en_US" ? payment.value = 4 : ''
})

onBeforeUnmount(() => {
  shoppingCart.$reset()
})

const mergeCustomAreaData = (item: any) => {
  return Object.assign(
    {},
    {
      image: renderImageBaseUrl(item),
      customArea: Object.assign(
        item.spu_custom_areas
        || {},
        { boundingRect: item.customized_areas?.boundingRect }
      ),
      customizedImage: item.image + `?x-oss-process=image/resize,w_50/quality,q_90` || "",
      width: 1000,
      height: 1000,
      cssWidth: 50,
      cssHeight: 50,
    },
  )
}

// 购物车弹窗
const showShoppingCart = ref<boolean>(false)
const changeDrawer = async () => {
  showShoppingCart.value = true
  tableRefList.value = []
  selectedItems.value = []
  selectedOrderAddressItem.value = []
  selectedOriginOrderAddressItem.value = []
  money.value = 0
  remarks.value = ''
}

// 切换优惠券tab
const changeTabList = async (e: string) => {
  if (e === '1') {
    await getMyCoupon()
  } else {
    getCoupon()
  }
}

// 获取我的优惠券
const getMyCoupon = async () => {
  await getMyCouponList(1).then((res: any) => {
    myCouponList.value = res
    filtrateCouponList()
  })
}

// 获取优惠券列表
const getCoupon = async () => {
  await getCouponList().then((res: any) => {
    notCollectedCoupon.value = res
  })
}

const getCoupons = async (info: SingleCoupon) => {
  receiveCoupon(info.id).then(res => {
    if (res == t('CustomSpus.ShoppingCart.couponReceived')) {
      info.status = 1
      message.success(t('CustomSpus.ShoppingCart.couponReceived'))
    }
  }).catch(((res) => {
    switch (res.code) {
      case 403:
        info.is_full = true
        message.error(t('CustomSpus.ShoppingCart.couponOutOfStock'))
        break

      case 500:
        info.status = 2
        message.error(t('CustomSpus.ShoppingCart.activityEnded'))
        break

      default:
        message.error(t('CustomSpus.ShoppingCart.receiveFailedRetry'))
        break
    }
  }))
  await getMyCoupon()
}

// 获取优惠券适用规则
const getCouponItemLayout = (couponItem: SingleCoupon) => {
  return {
    id: Number(couponItem.id),
    activity_name: couponItem.activity_name,
    activity_type: couponItem.activity_type,
    activity_scope: couponItem.activity_scope,// 适用范围
    is_stackable: couponItem.is_stackable, // 能否叠加
    activity_coupons: {
      claim_status: '',// 是否使用
      coupon_code: couponItem.ActivityUser?.coupon_code,// 优惠券码
    },
    discount_amount: couponItem.discount_amount ? Number(couponItem.discount_amount) : null,// 减免金额
    discount_rate: couponItem.discount_rate ? Number(couponItem.discount_rate) : null,// 折扣率
    threshold_amount: couponItem.threshold_amount ? Number(couponItem.threshold_amount) : 0,// 满减门槛
    start_time: couponItem.start_time, // 活动开始时间
    end_time: couponItem.end_time,// 活动结束时间
  } as CouponItem
}

// 优惠券过滤计算的数据整合
const getOrderFilterContent = () => {
  const order = {
    items: selectedItems.value?.map(x => {
      return {
        id: x.id,
        sku_id: x.sku_id,
        spu_id: x.spu_id,
        category_id: x.category_id,
        price_detail: {
          spu_price: Number(x.price_detail.spu_price),
          custom_price: x.price_detail.custom_price || [],
          sku_price: Number(x.price_detail.sku_price),
          spu_discount: x.price_detail.spu_discount
        },
        selectCoupon: x.selectCoupon || [],
        quality: x.quality,
      }
    }),
    selectCoupon: selectCouponList.value.length > 0 ? selectCouponList.value : []
  }

  const currentShowCoupon = commodityId.value ? selectedSpecificCouponList.value : selectedUniversalCouponList.value
  // 需要提供该订单item/all当前最新选中的优惠券  单个的话塞给单个的selectCoupon 通用的塞给通用的selectCoupon
  const selectCouponListItem = [] as CouponItem[]
  myCouponList.value.forEach(m => {
    currentShowCoupon.forEach((x) => {
      if (m.id === x.id && x.commodityId === commodityId.value) {
        selectCouponListItem.push(getCouponItemLayout(m))
      }
    })
  })

  const myList = myCouponList.value.map(x => {
    return getCouponItemLayout(x)
  })
  return {
    order, // 订单
    myList, // 所有优惠券列表
    selectCouponListItem // 当前最新选中的优惠券 后面需要判断单个还是通用 替换 order里面对应的selectCoupon
  }
}

// 优惠券过滤
const filtrateCouponList = () => {
  const { order, myList, selectCouponListItem } = getOrderFilterContent()

  let result = [] as CanUseResult[]
  if (commodityId.value) {
    // 单个商品筛选优惠券
    const currentCartOrder = order.items.find((r: any) => r.id === commodityId.value)

    if (currentCartOrder) {
      currentCartOrder.selectCoupon = selectCouponListItem
      result = coupon.canUseAtItem(order as Order, currentCartOrder as Item, myList as CouponItem[])
    }
  } else {
    order.selectCoupon = selectCouponListItem
    result = coupon.canUseAtOrder(order as Order, myList as CouponItem[])
  }

  myCouponList.value.forEach(x => {
    const val1 = result.filter(m => (m.id == x.id && !m.can))
    val1.length > 0 ? x.disabled = true : x.disabled = false
    const val2 = result.filter(m => (m.id == x.id))
    val2.length > 0 ? x.hide = false : x.hide = true
  })
}

const changeCoupon = () => {
  if (myCouponList.value.length || notCollectedCoupon.value.length)
    couponVisible.value = true
}



const clacDssImageAmount = (references: Reference[]) => {
  let amount = new BigNumber(0)
  if (references) {
    references.forEach((r: Reference) => {
      if (r.type === '2') {
        amount = amount.plus(r.customizedImage.ref_price)
      }
    })
  }
  return amount.toFixed(2)
}

const couponCanel = () => {
  if (commodityId.value) {
    selectedSpecificCouponList.value = []
    selectedSpecificCouponList.value = restoreSelectedCoupon.value
  }
  else {
    selectedUniversalCouponList.value = []
    restoreSelectedCoupon.value.forEach((r: SingleCoupon) => {
      if (!r.commodityId)
        selectedUniversalCouponList.value.push(r)
    })
  }
}

const couponSelectionShow = async (info?: ShoppingCartItem) => {
  if (!myCouponList.value.length && !notCollectedCoupon.value.length)
    return message.error(t('CustomSpus.ShoppingCart.noCouponsOrPendingCoupons'))

  activeKey.value = '1'
  // index 有值说明是 单个商品选择优惠  无值则是选择通用优惠

  if (info) {
    commodityId.value = info.id
    if (info.selectCoupon && info.selectCoupon.length > 0) {
      selectedSpecificCouponList.value = []
      info.selectCoupon.forEach((r: SingleCoupon) => {
        if (r.commodityId) {
          selectedSpecificCouponList.value.push(deepCopy(r))
        }
      })
    }
  } else {
    commodityId.value = 0
    if (selectCouponList.value.length > 0) {
      selectedUniversalCouponList.value = []
      selectCouponList.value.forEach((r: SingleCoupon) => {
        if (!r.commodityId)
          selectedUniversalCouponList.value.push(deepCopy(r))
      })
    }
  }

  restoreSelectedCoupon.value = []
  const currentShowCoupon = commodityId.value ? selectedSpecificCouponList.value : selectedUniversalCouponList.value
  restoreSelectedCoupon.value = deepCopy(currentShowCoupon)

  await getMyCoupon()

  couponVisible.value = true
}
const deepCopy = (value: any) => {
  if (!value) {
    return false
  }
  return JSON.parse(JSON.stringify(value))
}
const selectedCoupon = (item: SingleCoupon) => {
  if (item.disabled) {
    message.error(t('CustomSpus.ShoppingCart.couponNotApplicableToClothing'))
    return

  }

  const currentShowCoupon = commodityId.value ? selectedSpecificCouponList.value : selectedUniversalCouponList.value

  const findCoupon = currentShowCoupon.findIndex((r: SingleCoupon) => r.id === item.id)

  if (findCoupon === -1) {
    currentShowCoupon.push(item)
    currentShowCoupon[currentShowCoupon.length - 1].commodityId = commodityId.value
  } else {
    currentShowCoupon.splice(findCoupon, 1)
  }

  filtrateCouponList()
}

const couponOk = () => {
  couponVisible.value = false
  const { order, selectCouponListItem } = getOrderFilterContent()
  if (commodityId.value) {
    const tempConcat = selectCouponListItem.map((r: any) => Object.assign({}, (r), { commodityId: commodityId.value }))
    const currentCartOrder = selectedItems.value.find((r: ShoppingCartItem) => r.id === commodityId.value)
    if (currentCartOrder) {
      currentCartOrder.selectCoupon = tempConcat!
    }
    const currentOrder = order.items.find((r: any) => r.id === commodityId.value)
    if (currentOrder) {
      currentOrder.selectCoupon = selectCouponListItem
    }
  } else {
    order.selectCoupon = selectCouponListItem
    selectCouponList.value = selectCouponListItem
  }

  couponResult.value = coupon.calcDiscount(order as Order)
  if (couponResult.value) {
    adjustSelected.value.forEach((x: any) => {
      x.coupon_price = couponResult.value ? couponCalcPrice(couponResult.value.itemDiscount, x.id) : calcPrice.calcTotalPrice(x.price_detail, x.quality, false)
    })
  }

  if (commodityId.value) {
    let discountDetails = ''
    selectedSpecificCouponList.value.filter((r) => r.commodityId === commodityId.value).forEach((r: any, i: number) => {
      if (i > 0)
        discountDetails += '，'
      if (r.threshold_amount) {
        if (r.discount_rate)
          discountDetails += t('CustomSpus.ShoppingCart.full') + r.threshold_amount + t('CustomSpus.ShoppingCart.yuan') + removeLastZero(new BigNumber(r.discount_rate).times(100).toNumber()) + t('CustomSpus.ShoppingCart.discount')
        else
          discountDetails += t('CustomSpus.ShoppingCart.full') + r.threshold_amount + t('CustomSpus.ShoppingCart.yuanOff') + r.discount_amount + t('CustomSpus.ShoppingCart.yuan')
      } else {
        if (r.discount_rate)
          discountDetails += t('CustomSpus.ShoppingCart.noThreshold') + removeLastZero(new BigNumber(r.discount_rate).times(100).toNumber()) + t('CustomSpus.ShoppingCart.discount')
        else
          discountDetails += t('CustomSpus.ShoppingCart.noThreshold') + t('CustomSpus.ShoppingCart.directOff') + r.discount_amount + t('CustomSpus.ShoppingCart.yuan')
      }
    })

    const couponConditionIndex = couponCondition.value.findIndex((r: CouponCondition) => r.commodityId === commodityId.value)
    if (couponConditionIndex != -1) {
      couponCondition.value[couponConditionIndex].text = discountDetails
    } else {
      couponCondition.value.push({
        commodityId: commodityId.value,
        text: discountDetails
      })
    }
  }
}


// 购物车表格多选
const rowSelection: TableProps['rowSelection'] = {
  onChange: (selectedRowKeys: any, selectedRows: ShoppingCartItem[]) => {
    selectedRows.forEach((r: ShoppingCartItem) => {
      r.price_detail.spu_discount = accountInfoPlugin.options.baseDiscount.value
    })
    selectedItems.value = deepCopy(selectedRows)
    moneyTotal(selectedItems.value)
  }, getCheckboxProps: (record: ShoppingCartItem) => ({
    disabled: (record.isRemoved || record.price_detail.custom_price.some(res => res.deletedAt))
  })
}
const deleteVisible = ref(false)
const isDeleteAll = ref(false)
const deleteConfirmId = ref<number>(0)
const deleteContent = ref<string>('')

// 购物车单个删除
const deleteValue = async (value: ShoppingCartItem) => {
  deleteVisible.value = true
  deleteConfirmId.value = value.id
  deleteContent.value = t('CustomSpus.ShoppingCart.confirmRemoveProduct')
  isDeleteAll.value = false
}

const onDeleteOk = async () => {
  try {
    if (isDeleteAll.value) {
      await shoppingCart.deleteItems(deleteID.value)
      selectedItems.value = []
      money.value = 0
    } else {
      await shoppingCart.deleteItems(deleteConfirmId.value)
      selectedItems.value = selectedItems.value.filter(item => item.id != deleteConfirmId.value)
      moneyTotal(selectedItems.value)
    }
    await shoppingCart.fetch()
    deleteVisible.value = false
    deleteID.value.length = 0
    message.success(t('CustomSpus.ShoppingCart.deleteSuccess'))
  } catch (error) {
    console.log(error)
  }
}

// 购物车批量删除按钮
const deleteID = ref<number[]>([])
const batchDelete = async (value: ShoppingCartItem) => {
  deleteVisible.value = true
  deleteConfirmId.value = value.id
  deleteContent.value = t('CustomSpus.ShoppingCart.deleteSuccess')
  deleteID.value = selectedItems.value.map(item => item.id)
  isDeleteAll.value = true
}

// 购物车数量修改
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const qualityChange = async (value: ShoppingCartItem, event: any, action: any) => {
  switch (action) {
    case 'minus':
      value.quality--
      await quantityChange(value.id, value.quality)
      break
    case 'plus':
      value.quality++
      await quantityChange(value.id, value.quality)
      break
    case 'change':
      if (value.quality) {
        quantityChange(value.id, value.quality)
      }
      break
  }
}
const quantityChange = async (id: number, quality: number) => {
  try {
    await shoppingCart.updateQualityOfItem(id, quality)
    await shoppingCart.fetch()
    shoppingCart.items.forEach(shopItem => {
      selectedItems.value.forEach(selectedItem => {
        if (shopItem.id == selectedItem.id) {
          selectedItem.quality = shopItem.quality
        }
      })
    })
    moneyTotal(selectedItems.value)
  } catch (error) {
    console.log(error)
  }
}

const settlement = async () => {
  selectedItems.value.length
    ? (((confirm.value = true), (showShoppingCart.value = false), defaultAddress()),
      moneyTotal(selectedItems.value), weightTotal(selectedItems.value))
    : null

  if (confirm.value) {
    await getMyCoupon()
    await getCoupon()
  }
}
const weight = ref<number>(0)

const weightTotal = (value: ShoppingCartItem[]) => {
  weight.value = 0
  let weightNum = 0
  value.forEach((item: any) => {
    const weightAttr = item.sku_attrs?.find((a: any) => {
      return a.attribute.key === 'weight'
    })
    if (weightAttr) {
      weightNum = new BigNumber(weightNum).plus(new BigNumber(weightAttr.value).times(item.quality)).decimalPlaces(2).toNumber()
      // weight.value += weightAttr.value * item.quality
    }
  })
  return weightNum
}
const address = ref<any>({})
// 订单默认地址
const defaultAddress = async () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const res: any = fetchDefaultAddress()
  fetchDefaultAddress().then((result: any) => {
    const copyObject = deepCopy(selectedItems.value)
    copyObject.forEach((item: any) => {
      item.express_company_id = 17
    })
    tableRefList.value.push(copyObject)
    tableRefList.value.forEach(arrayItem => {
      arrayItem.forEach((item: any) => {
        item.address = result
        item.expressPrice = 0
      })
    })
  }).catch(() => {
    console.log('出错了')
  })
}


// 更换地址
// eslint-disable-next-line @typescript-eslint/no-explicit-any



// 订单总金额
const money = ref<number>(0)
const moneyTotal = (value: ShoppingCartItem[]) => {
  // money.value += item.customSpu.price * item.quality
  money.value = 0
  value.forEach((item) => {
    money.value = new BigNumber(money.value).plus(new BigNumber(calcPrice.calcTotalPrice(item.price_detail, item.quality, true)!)).toNumber()
  })
}



// 订单关闭，dom清空
const orderClose = () => {
  money.value = 0
  address.value = undefined
  confirm.value = false
  couponResult.value = undefined
  couponCondition.value = []
  myCouponList.value = []
  notCollectedCoupon.value = []
  selectedItems.value = []
  tableRefList.value = []
  selectedSpecificCouponList.value = []
  selectedUniversalCouponList.value = []
  restoreSelectedCoupon.value = []
  selectCouponList.value = []
  remarks.value = ''
  adjustActiveKey.value = ''
  isAdjust.value = false
}

// 备注
const remarks = ref('')

// 支付方式
const payment = ref(0)

// 地址选择框
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wxVisible = ref<boolean>(false)
const paypalVisible = ref<boolean>(false)
const code_img = ref('')
const number = ref<string>('')
const price = ref<string>('')
const adjustVisible = ref<boolean>(false)
const adjustActiveKey = ref()
const adjustTotalData = ref<AdjustItem>({
  pay_amount: 0,
  original_amonut: 0,
  rate: 0,
})
const adjustCustomData = ref<AdjustItem>({
  pay_amount: 0,
  original_amonut: 0,
  rate: 0,
})
const adjustSelected = ref()
// 调价弹框
const adjustPrice = (title: string) => {
  adjustActiveKey.value = title
  adjustVisible.value = true
  if (!isAdjust.value) {
    adjustCustomData.value.original_amonut = orderExpressPrice.value
    adjustSelected.value = selectedItems.value?.map(x => {
      return Object.assign(x, {
        price: calcPrice.calcTotalPrice(x.price_detail, x.quality, true),
        adjust_price: couponResult.value ? couponCalcPrice(couponResult.value.itemDiscount, x.id) : calcPrice.calcTotalPrice(x.price_detail, x.quality, true),
        coupon_price: couponResult.value ? couponCalcPrice(couponResult.value.itemDiscount, x.id) : calcPrice.calcTotalPrice(x.price_detail, x.quality, true)
      })
    })
    adjustSelected.value.forEach((item: any) => {
      adjustCustomData.value.original_amonut = new BigNumber(adjustCustomData.value.original_amonut).plus(item.coupon_price).toNumber()
    })
    adjustCustomData.value.pay_amount = adjustCustomData.value.original_amonut
    adjustTotalData.value.original_amonut = adjustCustomData.value.original_amonut
    adjustTotalData.value.pay_amount = adjustCustomData.value.original_amonut
  } else {
    let amount = orderExpressPrice.value
    adjustSelected.value.forEach((r) => {
      amount = new BigNumber(r.adjust_price).plus(amount).toNumber()
    })
    adjustCustomData.value.pay_amount = amount
    adjustCustomData.value.original_amonut = adjustDetail.value.original_amonut
    adjustTotalData.value.original_amonut = adjustDetail.value.original_amonut
  }
}
const couponCalcPrice = (discount: any[], id: number) => {
  let price = 0
  discount.forEach((el: { item_id: any; amount: any }) => {
    if (el.item_id == id) price = el.amount
  })
  return price
}
const adjustCancel = () => {
  adjustVisible.value = false
  adjustActiveKey.value = selectAdjustType.value
}
const rateChange = (pay_amount: number, original_amonut: number) => {
  return new BigNumber(pay_amount).div(original_amonut).times(100).toNumber().toFixed(2)
}
const isAdjust = ref<boolean>(false)
const adjustDetail = ref<AdjustItem>({
  pay_amount: 0,
  original_amonut: 0,
  rate: 0,
})
const selectAdjustType = ref<string>('')
const adjustSubmit = () => {
  selectAdjustType.value = adjustActiveKey.value
  if (adjustActiveKey.value == 'custom') {
    adjustDetail.value = {
      pay_amount: adjustCustomData.value.pay_amount,
      original_amonut: pay_money.value,
      rate: 0
    }
  } else {
    adjustDetail.value = {
      pay_amount: adjustTotalData.value.pay_amount,
      original_amonut: pay_money.value,
      rate: 0
    }
  }
  adjustDetail.value.rate = rateChange(adjustDetail.value.pay_amount, adjustDetail.value.original_amonut) as any
  adjustVisible.value = false
  isAdjust.value = true
}
const adjustPriceChange = () => {
  adjustCustomData.value.pay_amount = orderExpressPrice.value
  adjustSelected.value.forEach((item: any) => {
    adjustCustomData.value.pay_amount = new BigNumber(adjustCustomData.value.pay_amount).plus(item.adjust_price).toNumber()
  })
  adjustCustomData.value.rate = new BigNumber(adjustCustomData.value.pay_amount).div(adjustCustomData.value.original_amonut).times(100).toNumber().toFixed(2) as any
}
const onSubmitOrder = async () => {
  const pay_amount = userSale.value && isAdjust.value ? adjustDetail.value.pay_amount : pay_money.value
  if (payment.value == 3 && (!userAccount.value || userAccount.value.balance < pay_amount)) {
    return message.error(t('CustomSpus.ShoppingCart.insufficientBalance'))
  }
  const orderCart = deepCopy(tableRefList.value)
  const verify = orderCart.some((order: any) => {
    return order.some((res: any) => {
      return res.price_detail.custom_price.some((r: any) => r.deletedAt)
    })
  })
  if (verify) {
    return message.info(t('CustomSpus.ShoppingCart.productRemoval'))
  }
  modalLoading.value = true
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const carts = [] as any
  const sku_amount = new BigNumber((couponResult.value?.orderDiscount.amount || money.value)).decimalPlaces(2).toNumber()
  selectedItems.value?.forEach(item => {
    // sku_amount = item.quality
    // sku_amount = new BigNumber(sku_amount).plus(calculateTotalPrice(item.price_detail, item.quality)!).decimalPlaces(2).toNumber()
    const reorganization = [] as any
    selectedSpecificCouponList.value.forEach((r) => {
      if (r.commodityId === item.id)
        reorganization.push(getCouponItemLayout(r))
    })
    carts.push({
      id: item.id,
      quality: item.quality,
      spu_customable_image: item.spu_customable_image,
      spu_name: item.spu_name,
      custom_spu_name: item.custom_spu_name,
      image: item.image,
      sku_code: item.sku_code,
      sku_attrs: item.sku_attrs,
      custom_sku_id: item.custom_sku_id,
      spu_custom_height: item.spu_custom_height,
      spu_custom_width: item.spu_custom_width,
      spu_custom_areas: item.spu_custom_areas,
      custom_spu_id: item.custom_spu_id,
      spu_id: item.spu_id,
      sku_id: item.sku_id,
      is_custom: item.is_custom,
      price_detail: item.price_detail,
      category_id: item.category_id,
      selectCoupon: reorganization || [],
      dssData: item.dssData
    })
  })
  let orderAllExpressPrice = 0

  for (let i = 0; i < orderCart.length; i++) {
    for (let o = 0; o < orderCart[i].length; o++) {
      orderCart[i][o].address = {
        receiver: orderCart[i][o].address.name,
        receiver_phone: orderCart[i][o].address.phone,
        receiver_zipcode: orderCart[i][o].address.zipcode,
        receiver_province: orderCart[i][o].address.province.name,
        receiver_city: orderCart[i][o].address.city.name,
        receiver_district: orderCart[i][o].address.district.name,
        receiver_street: orderCart[i][o].address.street.name,
        receive_address: orderCart[i][o].address.address,
        express_fee: orderCart[i][o].expressPrice,
        express_company_id: orderCart[i][o].express_company_id,
        express_number: orderCart[i][o].express
      }
    }
    orderAllExpressPrice += orderCart[i][0].expressPrice
  }
  const reorganization = selectedUniversalCouponList.value.map((r) => {
    return getCouponItemLayout(r)
  })
  let adjustdata = {} as any
  let adjust_sku = 0
  if (userSale.value) {
    adjustDetail.value.rate = rateChange(adjustDetail.value.pay_amount, adjustDetail.value.original_amonut) as any
    const data = Object.assign(adjustDetail.value, { is_total: selectAdjustType.value == 'total' }) as any
    if (selectAdjustType.value == 'custom') {
      const adjustItem = [] as any
      adjustSelected.value.forEach((r: any) => {
        adjustItem.push({
          id: r.id,
          sku_amount: r.adjust_price,
          original_amonut: r.coupon_price,
          rate: rateChange(r.adjust_price, r.coupon_price)
        })
        adjust_sku += r.adjust_price
      })
      data.adjustItem = adjustItem
      data.express_fee = orderAllExpressPrice
    } else {
      data.express_fee = new BigNumber(orderAllExpressPrice).times(adjustDetail.value.rate).div(100).toFixed(2)
      adjust_sku = new BigNumber(adjustDetail.value.pay_amount).minus(data.express_fee).toFixed(2) as any
    }
    adjustdata = data
  }
  const submitForm = {
    pay_amount: userSale.value && isAdjust.value ? adjustdata.pay_amount.toString() : pay_money.value.toString(),
    sku_amount: userSale.value && isAdjust.value ? adjust_sku.toString() : sku_amount.toString(),
    receiver: orderCart[0][0].address.receiver,
    receiver_phone: orderCart[0][0].address.receiver_phone,
    receiver_zipcode: orderCart[0][0].address.receiver_zipcode,
    receiver_province: orderCart[0][0].address.receiver_province,
    receiver_city: orderCart[0][0].address.receiver_city,
    receiver_district: orderCart[0][0].address.receiver_district,
    receiver_street: orderCart[0][0].address.receiver_street,
    receive_address: orderCart[0][0].address.receive_address,
    pay_type: payment.value,
    remark: remarks.value,
    express_fee: orderAllExpressPrice,
    express_company_id: orderCart[0][0].express_company_id,
    cart: carts,
    orderCart,
    selectCoupon: reorganization || [],
    discount_amount: couponResult.value ? couponResult.value?.discount : 0,
    adjustdata: userSale.value && selectAdjustType.value != '' ? adjustdata : null
  }
  await addOrder(submitForm)
    .then(async (res: any) => {
      if (submitForm.pay_amount === '0' || payment.value == 3) {
        router.push('/console/orders/order_management')
      } else {
        payment.value === 0 ? window.location.href = res.url : ''
        if (payment.value === 1) {
          code_img.value = await QRCode.toDataURL(res.url)
          number.value = res.number
          wxVisible.value = true
        }
        if (payment.value === 4 && locale.value == 'en_US') {
          paypalVisible.value = true
          number.value = res.number
          price.value = res.pay_amount
        }
      }
      modalLoading.value = false
      shoppingCart.fetch()
      orderClose()
    }).catch((err) => {
      modalLoading.value = false
      message.error(err.message)
    })
}
const router = useRouter()
const onCancelOk = async () => {
  const data = { number: `${number.value}-PC` }
  const res: any = await wxpayQuery(data)
  res.result.result_code == 'SUCCESS' && res.result.trade_state == 'SUCCESS' ? message.success(res.result.trade_state_desc) : message.error(res.result.trade_state_desc)
  await shoppingCart.fetch()
  wxVisible.value = false
  confirm.value = false
  showShoppingCart.value = false
  remarks.value = ''
  router.push('/console/orders/order_management')
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const convertAttrs = (attrs: any[]) => {
  const arr = [] as any
  attrs.forEach((a) => {
    const data = {
      name: '',
      value: ''
    }
    data.name = a.attribute.name
    data.value = a.object_value ? a.object_value.name : a.value
    arr.push(data)
  })
  arr.sort(sortBy('name', false))
  return arr
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const colorOfItem = (item: any): Color | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const colorAttr = item.sku_attrs?.find((a: any) => {
    return a.attribute.key === 'color'
  })
  if (colorAttr) {
    return convertColor(colorAttr.value || colorAttr.object_value)
  }
  return undefined
}
const expressPrice = ref<number>(NaN)
const express_company_id = ref<number>(0)
// 选择快递
const expressChange = async (e?: any) => {

  if (express.value == 17) {
    expressPrice.value = 0
    return
  }
  express_company_id.value = e ? e.target.value : express_company_id.value
  if (!address.value.province) return
  const express_data = {
    express_company_id: express_company_id.value,
    destination_code: address.value?.province.code,
    weight: weight.value
  }
  const price: any = await getExpressRate(express_data)
  expressPrice.value = new BigNumber(price.price).decimalPlaces(2).toNumber()
}

watch(address, () => {
  express_company_id.value !== 0 ? expressChange() : ''
}, { deep: true })

const pay_money = computed(() => {
  const amount = couponResult.value?.orderDiscount.amount
  let orderExpressPrice = 0
  if (tableRefList.value.length > 0) {
    tableRefList.value.forEach(tableData => {
      tableData.forEach((item: any, index: number) => {
        if (index === 0) {
          orderExpressPrice += item.expressPrice
        }
      })
    })
  }
  const pay_fee = BigNumber(((amount || amount === 0) ? amount : money.value)).plus(orderExpressPrice).decimalPlaces(2).toNumber()
  // eslint-disable-next-line vue/no-side-effects-in-computed-properties
  adjustDetail.value.original_amonut = pay_fee
  // return money.value + expressPrice.value * 1
  return pay_fee
})
const adjust_money = () => {
  let amount = orderExpressPrice.value
  if (isAdjust.value && selectAdjustType.value == 'custom') {
    adjustSelected.value.forEach((r) => {
      amount = new BigNumber(r.adjust_price).plus(amount).toNumber()
    })
    adjustDetail.value.pay_amount = amount
    adjustCustomData.value.pay_amount = amount
  }
  if (isAdjust.value && selectAdjustType.value == 'total') {
    amount = adjustTotalData.value.pay_amount
  }
  return amount
}
const orderExpressPrice = computed(() => {
  let price = 0
  if (tableRefList.value.length > 0) {
    tableRefList.value.forEach(tableData => {
      tableData.forEach((item: any, index: number) => {
        if (index === 0) {
          price += item.expressPrice
        }
      })
    })
  }
  // return money.value + expressPrice.value * 1
  return price
})

</script>
<style scoped lang="less">
.coupon-list-selected {
  cursor: pointer;
  display: flex;
  width: 100%;
  height: 130px;
  overflow-x: auto;
  white-space: nowrap;

  .selected-coupon {
    background: url(../icon/coupon-bg-selected.png) no-repeat center/cover !important;
    background-size: 100% 100% !important;
  }

  .coupon-details {
    min-width: 20%;
    height: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    // background: url(../icon/coupon-bg.png) 0 0/cover no-repeat;
    background: url(../icon/coupon-bg.png) no-repeat center/cover;
    background-size: 100% 100%;

    .coupon-price {
      display: flex;
      align-items: center;

      .coupon-symbol {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #111111;
      }

      .coupon-amount {
        padding: 0 5px;
        font-size: 40px;
        font-family: DIN;
        font-weight: bold;
        color: #111111;
        background: linear-gradient(-45deg, #FF9000 0%, #DE4A09 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .coupon-rule {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #111111;
    }

    .coupon-reject {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }
  }
}

.no-coupon-message {
  min-height: 200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999999;
}

.coupon-list {
  // display: flex;
  width: 100%;
  min-height: 200px;
  max-height: 500px;
  // flex-wrap: wrap;
  // justify-content: space-evenly;
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  padding: 0 20px;

  .selected-coupon {
    background: url(../icon/coupon-bg-selected.png) no-repeat center/cover !important;
    background-size: 100% 100% !important;
  }

  .coupon-waiting {
    cursor: pointer;
    background: url(../icon/waitingCollect.png) no-repeat center/cover !important;
    background-size: 100% 100%;
  }

  .coupon-details {
    margin-top: 10px;
    width: 100%;
    height: 150px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    // background: url(../icon/coupon-bg.png) 0 0/cover no-repeat;
    background: url(../icon/coupon-bg.png) no-repeat center/cover;
    background-size: 100% 100%;

    .coupon-price {
      display: flex;
      align-items: center;

      .coupon-symbol {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #111111;
      }

      .coupon-amount {
        padding: 0 5px;
        font-size: 40px;
        font-family: DIN;
        font-weight: bold;
        color: #111111;
        background: linear-gradient(-45deg, #FF9000 0%, #DE4A09 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .coupon-rule {
        padding-top: 25px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #111111;
      }
    }

    .coupon-date {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #DE4A09;
    }



    .coupon-unaccalimed {
      padding-top: 15px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }

    .coupon-received {
      padding-top: 15px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
  }
}

.tab {
  :deep(.ant-tabs-nav-wrap) {
    padding-top: 5px;
    padding-left: 20px;
  }

  :deep(.ant-tabs-tab) {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #999999;
  }

  :deep(.ant-tabs-tab-active) {
    color: #111111;
  }

  :deep(.ant-tabs-content) {
    height: 100%;
  }
}

.cart {
  cursor: pointer;
  height: 0;
  margin: 2px 18px 0 0;

  :deep(.ant-badge) {
    font-family: 'Microsoft YaHei';
    font-size: 14px;
    color: white;
  }

  .cart-icon {
    font-size: 15px;
  }
}

.coupon-remind {
  cursor: pointer;

  img {
    width: 15px;
    height: 15px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #DE4A09;
}

.no-coupon-remind {
  cursor: pointer;

  img {
    width: 15px;
    height: 15px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #CCCCCC;
}

.coupon {
  width: 150px;
  height: 80px;
  background: url(../icon/oval.png) 0 0/contain no-repeat;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  p {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }

  span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #111111;
  }
}

.aftercoupon {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  .yellow-style {
    color: #DE4A09;
  }
}

.technology-name {
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  align-items: center;
}

.yellow-style {
  color: #DE4A09;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon-margin {
    margin-left: 10px;
    color: #999;
  }

  .black-style {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #111111;
  }

  .former-price {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #CCCCCC;
    text-decoration: line-through;
  }

}


.flex-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 30px;

  .image-box {
    width: 80px;
    height: 80px;
    background-color: #F6F6F6;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: none;

    img {
      width: 100%;
    }
  }

  .item-flex {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    margin-left: 20px;
    text-align: start;

    .name_color {
      font-size: 16px;
    }

    .attr_color {
      color: #999;
      margin-right: 5px;
    }
  }
}

.shopping-cart-drawer {
  :deep(.ant-table-tbody) {
    font-size: 13px;
    color: #696768;
  }

  .container-table {
    margin-top: 50px;
    margin-bottom: 50px;
  }

  .settle-table {
    border: 1px solid #F1F1F1;
  }

  .hidden {
    width: 72px;
    height: 72px;
    position: absolute;
    visibility: hidden;
    display: block;
  }

  .viewer {
    width: 72px;
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: center;

    @-moz-document url-prefix() {
      :deep(.fabric-div) {
        width: 72px !important;
        height: 72px !important;
      }

      :deep(.canvas-container) {
        width: 72px !important;
        height: 72px !important;
      }

      :deep(.lower-canvas) {
        width: 72px !important;
        height: 72px !important;
      }

      :deep(.upper-canvas) {
        width: 72px !important;
        height: 72px !important;
      }
    }
  }


  :deep(.ant-table-tbody .ant-table-cell) {
    height: 116px !important;
    padding: 0;
  }

  .quantity-input {
    width: 124px;
    text-align: center;

    :deep(.ant-input-group-addon) {
      padding: 0;
      width: 32px;
      height: 32px;
    }

    :deep(.ant-input) {
      height: 32px;
      padding: 0;
    }

    .input-change {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background-color: #F6F6F6;
    }

    .input-disabled {
      cursor: not-allowed;
    }
  }

  .delete_btn {
    width: 100%;
    height: 116px;
    line-height: 116px;
    color: #DE4A09;
    cursor: pointer;
    user-select: none;
  }

  .delete_btn:hover {
    background: rgba(222, 74, 9, .15);
  }

}

.delete-button {
  width: 68px;
  height: 40px;
  background: #de4a092b;
  color: #de4a09;
  padding: 0;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;

  .delete-icon {
    font-size: 16px;
  }
}

.delete-button:hover {
  background: #de4a092b;
  color: #de4a09;
  border: 1px solid #de4a09;
}

.flex-amount {
  display: flex;
  align-items: center;
  margin-right: 20px;

  .amount-title {
    font-size: 14px;
  }

  .amount-price {
    font-size: 20px;
    font-family: 'Microsoft YaHei Bold';
    color: #DE4A09;
  }

  .former-price {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #CCCCCC;
    text-decoration: line-through;
    margin-left: 5px;
  }
}

.settle-btn {
  width: 120px;
  height: 40px;
}

.fabric-image {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.box-border {
  border: 1px solid #e1e1e1;
  margin-bottom: 15px;
  padding-left: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  :deep(.ant-radio-wrapper) {
    align-items: center;
  }

  .box-flex {
    height: 64px;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
  }

  .box-margin {
    height: 64px;
    border: 1px solid #F1F1F1;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .address-font {
    font-family: 'Microsoft YaHei Bold';
    border: none;
  }

  .box-edit {
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    color: #999999;
    cursor: pointer;
  }

  .box-edit:hover {
    background: #F1F1F1;
  }
}

.order {
  .order-title {
    font-size: 16px;
    margin-bottom: 14px;
    margin-top: 20px;
  }

  .order-express {
    float: right;
    margin-right: 10px;
  }

  .express-self-pickup {
    margin-left: 14px;
    color: #999999;
  }

  .order-title:nth-child(1) {
    margin-top: 0;
  }


}

.dropDownBox {
  .dropDownIcon {
    width: 15px;
    height: 16px;
  }

  span {
    margin-left: 11px;
    font-size: 14px;
    font-weight: 400;
    color: #111111;
  }
}

.flex {
  display: flex;
  justify-content: center;
}

.modal-btn {
  width: 98px;
  height: 40px;
}

.btn-bgc {
  background: #F6F6F6;
  color: #999999;
  border: none;
}

.content-size {
  font-size: 16px;
}

.adjust-content {

  .adjust-price {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 140px;
  }

  .adjust-min-price {
    color: #999999;
    margin-left: 10px;
  }

  .adjust-price-color {
    color: #DE4A09
  }
}
</style>
